<div class="www-exp">
  <h2
    class="www-exp__tit"
    (click)="isOpened.set(!isOpened())"
    appGtmClick
    [layer]="{
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: 'my data page',
      eventAction: 'select::' + (isOpened() ? 'close ' : 'open ') + title() + ' section',
      eventLabel: (isOpened() ? 'close ' : 'open ') + title() + ' section',
      event_name: 'body_button_click',
      module_name: (isOpened() ? 'close ' : 'open ') + title() + ' section',
      cta_name: (isOpened() ? 'close ' : 'open ') + title() + ' section',
      link_url: '',
    }"
  >
    {{ title() }} <img class="arrow" [ngClass]="{ closed: isOpened() }" src="assets/images/pages/my-data/arrow.svg" />
  </h2>
  @if (isOpened()) {
    <div
      class="www-exp__cont"
      [ngClass]="{ expanded: isOpened(), close: isOpened() === false }"
      [appAnimate]="'landing'"
      [speed]="'fast'"
    >
      <ng-content></ng-content>
    </div>
  }
</div>
